import 'magnific-popup';

$(() => {
  // ポップアップを開く
  const opneMagnificPopup = id => {
    $.magnificPopup.open({
      items: {src: '#' + id},
      type: 'inline',
      fixedContentPos: true
    }, 0);
  };

  // コメント削除用ポップアップを開く
  $('.delete_blog_article_comment').click(function () {
    const commentId = $(this).data('blog-article-comment-id');
    const url = '/delete_blog_article_comment/' + commentId;
    $('#popup_confirm > .btn_area > .delete').attr('href', url);
    opneMagnificPopup('popup_delete_comment');
  });


  // 確認ダイアログを閉じる
  $('.back').click(function () {
    $.magnificPopup.close();
  })

});
